/**
 * Mağaza konumları — dashboard haritasında logo ile gösterilir.
 */
export const SHOPS = [
  {
    id: '1',
    name: 'Mağaza 1',
    address: '',
    lat: 40.958727817818726,
    lng: 28.823933496955892,
  },
  {
    id: '2',
    name: 'Mağaza 2',
    address: '',
    lat: 41.0729415373031,
    lng: 28.738665420708564,
  },
  {
    id: '3',
    name: 'Mağaza 3',
    address: '',
    lat: 41.03462472076415,
    lng: 28.835482435545792,
  },
  {
    id: '4',
    name: 'Mağaza 4',
    address: '',
    lat: 41.05971316779632,
    lng: 28.8403155680264,
  },
  {
    id: '5',
    name: 'Mağaza 5',
    address: '',
    lat: 36.753538114232086,
    lng: 28.942972027369585,
  },
];

export function getMapCenter(shops) {
  const list = shops?.filter((p) => Number.isFinite(p.lat) && Number.isFinite(p.lng)) ?? [];
  if (!list.length) return [41.0082, 28.9784];
  const lat = list.reduce((s, p) => s + p.lat, 0) / list.length;
  const lng = list.reduce((s, p) => s + p.lng, 0) / list.length;
  return [lat, lng];
}
